import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ResetPasswordPage.Content', {
    emailRequired: 'The email address is required.',
    emailInvalid: 'The email address is not valid.',
    emailLabel: 'Email',
    emailPlaceholder: 'Enter email...',
    titleSuccess: 'Check your inbox',
    descriptionSuccess: 'We have just sent a password reset link email to {email}',
    title: 'Reset your password',
    resetButton: 'Send me a password reset email',
    loginNowButton: 'Log in now',
});
